module.exports = __webpack_public_path__ + "media/images/pic/labels/a1_2-fd18cf84a0ae62d524cad15d8b09c9ba.png";